'use client';

import { TelegramProductExtendedDto, useTelegramProductsUserBanReasonsViewed } from '@/generated';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import React, { useEffect } from 'react';

type Props = {
  product: TelegramProductExtendedDto;
};

export const ProductDeclined: React.FC<Props> = ({ product }) => {
  const t = useTranslations('product');

  const { mutateAsync: viewRejection } = useTelegramProductsUserBanReasonsViewed();

  useEffect(() => {
    if (
      !product.banReasonsViewedAt &&
      product.rejectionReasons?.length &&
      (product.status === 'Banned' || product.status === 'ModerationRejected')
    ) {
      viewRejection({ id: product.id });
    }
  }, [product, viewRejection]);
  return (
    <div className='w-full flex flex-col gap-[16px] p-[16px] mt-[12px] rounded-[16px] bg-[#FFE5E5] text-text-error'>
      <div className='flex gap-[8px] items-center'>
        <Image src='/assets/icons/ban.svg' height={24} width={24} alt='' />
        <div className='text-lg font-medium'>{t('rejected')}</div>
      </div>

      <div className='flex flex-col text-m'>
        <div>{t('reasons')}</div>
        {product.rejectionReasons?.map((val) => (
          <div key={val.id}>{val.name}</div>
        ))}
        <div>{t('reasons_end')}</div>
      </div>
    </div>
  );
};
